import {
	DyteAudioVisualizer,
	DyteAvatar,
	DyteControlbarButton,
	DyteMeeting,
	DyteNameTag,
	DyteParticipantTile,
	DyteParticipantsAudio,
	DyteScreenshareView,
	defaultIconPack,
} from '@dytesdk/react-ui-kit';
import { useDyteMeeting } from '@dytesdk/react-web-core';
import { DyteParticipant } from '@dytesdk/web-core';
import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { isUserAdmin } from 'shared-utils';
import { useUserContext } from 'src/context/UserProvider';
import { exitFullSreen, requestFullScreen } from 'src/utils/browser';
type Props = {
	participant?: DyteParticipant;
	hostParticipant?: DyteParticipant;
	studentParticipant?: DyteParticipant;
	// allParticipants?: DyteParticipant[];
	screenShareParticipant?: DyteParticipant;
};
const PostJoinedSessionScreen = ({
	hostParticipant,
	studentParticipant,
	participant,
	screenShareParticipant,
}: Props) => {
	const dyteMeeting = useDyteMeeting();
	const ref = useRef<HTMLDyteParticipantTileElement>(null);
	const [isScreenTileAccordianOpen, setIsScreenTileAccordianOpen] = useState<boolean>(true);
	const { user } = useUserContext();
	const isAdmin = user?.role && isUserAdmin(user?.role);
	const isMobile = useMediaQuery('(max-width: 960px)');
	return (
		<div className="h-full flex-1">
			<DyteParticipantsAudio meeting={dyteMeeting.meeting} />
			<div className="flex justify-center gap-4">
				{isAdmin ? (
					<>
						{studentParticipant && (
							<DyteParticipantTile
								ref={ref}
								participant={studentParticipant}
								meeting={dyteMeeting.meeting}
								// style={{ height: '180px', width: '320px' }}
								className="relative"
							>
								<DyteAvatar size={isMobile ? 'sm' : 'lg'} />
								<DyteNameTag participant={studentParticipant}>
									<DyteAudioVisualizer slot="start" participant={studentParticipant} />
								</DyteNameTag>
							</DyteParticipantTile>
						)}
						{hostParticipant && (
							<DyteParticipantTile
								ref={ref}
								participant={hostParticipant}
								meeting={dyteMeeting.meeting}
								// style={{ height: '180px', width: '320px' }}
								className="relative"
							>
								<DyteAvatar size={isMobile ? 'sm' : 'lg'} />
								<DyteNameTag participant={hostParticipant}>
									<DyteAudioVisualizer slot="start" participant={hostParticipant} />
								</DyteNameTag>
							</DyteParticipantTile>
						)}
					</>
				) : (
					<>
						{participant && (
							<DyteParticipantTile
								ref={ref}
								participant={participant}
								meeting={dyteMeeting.meeting}
								// style={{ height: '180px', width: '320px' }}
								className="relative"
							>
								<DyteAvatar size={isMobile ? 'sm' : 'lg'} />
								<DyteNameTag participant={participant}>
									<DyteAudioVisualizer slot="start" participant={participant} />
								</DyteNameTag>
							</DyteParticipantTile>
						)}

						{dyteMeeting.meeting.self && (
							<DyteParticipantTile
								ref={ref}
								participant={dyteMeeting.meeting.self}
								meeting={dyteMeeting.meeting}
								// style={{ height: '180px', width: '320px' }}
								className="relative"
							>
								<DyteAvatar size={isMobile ? 'sm' : 'lg'} />
								<DyteNameTag participant={dyteMeeting.meeting.self}>
									<DyteAudioVisualizer slot="start" participant={dyteMeeting.meeting.self} />
								</DyteNameTag>
							</DyteParticipantTile>
						)}
					</>
				)}
			</div>
			{screenShareParticipant ? (
				<div>
					<div className="border-[0.5px] border-solid border-[#3e3e3e] p-1">
						{isScreenTileAccordianOpen ? (
							<FaMinus
								className="cursor-pointer"
								onClick={() => setIsScreenTileAccordianOpen(!isScreenTileAccordianOpen)}
							/>
						) : (
							<FaPlus
								className="cursor-pointer"
								onClick={() => setIsScreenTileAccordianOpen(!isScreenTileAccordianOpen)}
							/>
						)}
					</div>
					{isScreenTileAccordianOpen ? (
						<div className="mt-1">
							<DyteScreenshareView
								meeting={dyteMeeting.meeting}
								participant={screenShareParticipant}
								style={{ height: '180px', width: '320px' }}
							>
								<DyteNameTag participant={screenShareParticipant}>
									<DyteAudioVisualizer slot="start" participant={screenShareParticipant} />
								</DyteNameTag>
							</DyteScreenshareView>
						</div>
					) : null}
				</div>
			) : null}
		</div>
	);
};

export default PostJoinedSessionScreen;
